import clsx from 'clsx';
import { useNavigate } from 'react-router-dom';

type FooterLinkProps = {
  title: string;
  href?: string;
  target?: '_blank' | '_self';
  variant?: 'default' | 'sectionTitle';
};

const variantStyles: Record<string, string> = {
  default: 'text-sm font-medium text-gray-600',
  sectionTitle: 'text-sm font-semibold text-gray-900 mb-2',
};

export default function FooterLink({ title, href, target, variant = 'default' }: FooterLinkProps) {
  const navigate = useNavigate();

  const handleClick = (e?: React.MouseEvent) => {
    if (!href) return;
    e?.preventDefault();

    if (target === '_blank') {
      window.open(href, '_blank');
    } else {
      navigate(href);
    }
  };

  return (
    <div className="rounded-md flex justify-start items-center gap-2">
      <a href={href} onClick={handleClick} className={clsx(variantStyles[variant], { 'cursor-pointer': !!href })}>
        {title}
      </a>
    </div>
  );
}
